import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { useTheme } from '../contexts/ThemeContext';

export default function PhoneStatsChart({ data }) {
    const { theme } = useTheme();
    const darkMode = theme === 'dark';
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    // Helper: Generate chart option based on dark mode
    const getChartOption = (darkMode) => {
        const maxValue = 2000;
        return {
            backgroundColor: 'transparent',
            tooltip: { trigger: 'axis' },
            xAxis: {
                type: 'category',
                data: ['Total Phones', 'Valid Phones', 'Complete Phones', 'Unique Area codes'],
                axisLabel: { color: darkMode ? '#f9fafb' : '#111827' } // Tailwind gray-50 / gray-900
            },
            yAxis: {
                type: 'value',
                max: maxValue,
                axisLabel: { color: darkMode ? '#f9fafb' : '#111827' }
            },
            series: [
                {
                    data: Array(5).fill(maxValue),
                    type: 'bar',
                    barGap: '-100%',
                    barWidth: 30,
                    itemStyle: {
                        color: darkMode
                            ? 'rgba(255,255,255,0.2)'
                            : 'rgba(180,180,180,0.3)'
                    },
                    z: 1
                },
                {
                    data: [
                        data.total_phones,
                        data.valid_phones,
                        data.complete_phones,
                        data.unique_area_codes
                    ],
                    type: 'bar',
                    barWidth: 30,
                    itemStyle: {
                        color: darkMode ? '#4FC3F7' : '#5470C6'
                    },
                    z: 2
                }
            ]
        };
    };

    // Initialize chart
    useEffect(() => {
        chartInstance.current = echarts.init(chartRef.current, null, { renderer: 'svg' });
        chartInstance.current.setOption(getChartOption(darkMode));

        const handleResize = () => chartInstance.current?.resize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            chartInstance.current?.dispose();
        };
    }, []); // only once on mount

    // Update chart when theme or data changes
    useEffect(() => {
        if (chartInstance.current) {
            chartInstance.current.setOption(getChartOption(darkMode), true);
        }
    }, [darkMode, data]);

    return <div ref={chartRef} style={{ width: '100%', height: '400px' }} />;
}
